import { render, staticRenderFns } from "./AddPrimaryDriver.vue?vue&type=template&id=1051af02&"
import script from "./AddPrimaryDriver.vue?vue&type=script&lang=js&"
export * from "./AddPrimaryDriver.vue?vue&type=script&lang=js&"
import style0 from "./AddPrimaryDriver.vue?vue&type=style&index=0&id=1051af02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports